var parse=require('../parse/index.js');var getDaysInMonth=require('../get_days_in_month/index.js');/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */function addMonths(dirtyDate,dirtyAmount){var date=parse(dirtyDate);var amount=Number(dirtyAmount);var desiredMonth=date.getMonth()+amount;var dateWithDesiredMonth=new Date(0);dateWithDesiredMonth.setFullYear(date.getFullYear(),desiredMonth,1);dateWithDesiredMonth.setHours(0,0,0,0);var daysInMonth=getDaysInMonth(dateWithDesiredMonth);// Set the last day of the new month
// if the original date was the last day of the longer month
date.setMonth(desiredMonth,Math.min(daysInMonth,date.getDate()));return date;}module.exports=addMonths;